import React from 'react';
import PropTypes from 'prop-types';

import { Box } from '@material-ui/core';

import { colors } from '../../theme/colors';

const styles = {
  boxShadow: '0px 6px 16px rgba(0, 0, 0, 0.05)',
  borderRadius: 4,
  backgroundColor: colors.white,
};

function Card({ children, style = {}, ...props }) {
  return (
    <Box style={{ ...styles, ...style }} {...props}>
      {children}
    </Box>
  );
}

Card.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  style: PropTypes.object,
};

export { Card };
